import React from "react";

import {
  withTheme,
  Dialog,
  Slide,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  ListItem,
  Badge,
  Avatar,
  ListItemText,
  Divider,
  List,
  CircularProgress,
} from "@material-ui/core";
import {
  Close,
  AddCircleOutline,
  RemoveCircleOutline,
} from "@material-ui/icons";
// import Swipe from 'react-easy-swipe'
import { getImageUrl } from "../../framework/getImageUrl";
import s from "./reorder.module.css";
import { theme } from "../../framework/theme";
import GlobalContext from "../../context/globalContext";

import { isBrowser } from "react-device-detect";

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class ReorderDialog extends React.Component {
  static contextType = GlobalContext;
  constructor(props) {
    super(props);
    this.state = {
      pendingUnFavorited: [],
      closing: false,
    };
  }

  toggleUpcFavorite = async (item) => {
    let prevState = this.state.pendingUnFavorited;
    let itemUuid = prevState.find((x) => x === item.uuid);
    if (!itemUuid) {
      prevState.push(item.uuid);
      const nextState = prevState;
      this.setState({ pendingUnFavorited: nextState });
    } else {
      prevState.splice(item.uuid);
      const nextState = prevState;
      this.setState({ pendingUnFavorited: nextState });
    }
  };

  addItem = async (item) => {
    await this.context.global.modifyShoppingCart(item, false);
    // this.context.global.getUserReorderItems();
  };

  removeItem = async (item) => {
    await this.context.global.modifyShoppingCart(item, true);
    // this.context.global.getUserReorderItems();
  };

  closeReorder = async () => {
    this.setState({ closing: true });
    for (let i = 0; i < this.state.pendingUnFavorited.length; i++) {
      await this.context.global.toggleUpcFavorite({
        uuid: this.state.pendingUnFavorited[i],
      });
    }
    this.setState({ pendingUnFavorited: [] });
    // this.context.global.setGlobalState('reorderDialogState', false)
    this.context.global.handleDashboardActions("BACK", "reorderDialogState");
    this.setState({ closing: false });
    this.context.global.setGlobalState(
      "bottomNavigationValue",
      "homeDialogState"
    );
    this.context.global.submitShoppingCartChanges();
  };

  render() {
    const { closing } = this.state;
    const { reorderDialogState } = this.context.global.data;

    let reorderItems;
    if (
      this.context.global.data.reorderItems &&
      this.context.global.data.reorderItems.length > 0
    ) {
      reorderItems = this.context.global.data.reorderItems;
    } else {
    }

    return (
      <Dialog
        fullScreen
        open={reorderDialogState}
        onClose={this.closeReorder}
        TransitionComponent={Transition}
        scroll={"paper"}
        style={{ zIndex: 90002 }}
      >
        <AppBar className={s.shoppingCartAppBar}>
          <Toolbar className={s.shoppingCartToolbar}>
            <div className={s.appBarContentContainer}>
              <div className={s.addressContainer}>
                <Typography variant="body1" style={{ color: "white" }}>
                  Previously Purchased Items
                </Typography>
              </div>
            </div>
            <div className={s.closeButtonContainer}>
              <IconButton
                color="inherit"
                onClick={this.closeReorder}
                aria-label="Close"
                className={s.shoppingCartAppBar}
              >
                <Close />
              </IconButton>
            </div>
          </Toolbar>
        </AppBar>
        <div style={{ marginTop: "70px" }} />
        {closing ? (
          <div
            style={{
              height: 100,
              textAlign: "center",
              padding: "2rem 0 2rem 0",
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <>
            {/* {isBrowser ? null : (
              <div className={s.swipeInfo}>
                <div className={s.swipeInfoDirections}>
                  <ArrowBack className={s.swipeIcon} />
                  <div>REMOVE</div>
                </div>
                <div className={s.swipeInfoDirections}>Swipe to Modify Cart</div>
                <div className={s.swipeInfoDirections} style={{ justifyContent: 'flex-end' }}>
                  <div>ADD</div>
                  <ArrowForward className={s.swipeIcon} />
                </div>
              </div>
            )} */}

            <div style={{ marginTop: "10px" }} />
            {reorderItems ? (
              <List className={s.shoppingCartListContainer}>
                <div>
                  {reorderItems.map((item) => {
                    return (
                      <ShoppingListItem
                        key={item.uuid}
                        item={item}
                        addItem={(item) => this.addItem(item)}
                        removeItem={(item) => this.removeItem(item)}
                        toggleUpcFavorite={(item) =>
                          this.toggleUpcFavorite(item)
                        }
                        pendingUnFavorited={this.state.pendingUnFavorited}
                      />
                    );
                  })}
                </div>
              </List>
            ) : (
              <Typography
                variant="body1"
                style={{
                  // color: theme.palette.primary.main,
                  color: "#222222",
                  padding: "50px 20px",
                  textAlign: "center",
                }}
              >
                No previous purchases yet!
              </Typography>
            )}
          </>
        )}
      </Dialog>
    );
  }
}

export default withTheme()(ReorderDialog);

class ShoppingListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      left: 0,
      fixed: false,
      addOrSubtract: "add",
      yPosition: 0,
    };
  }
  render() {
    const { item, addItem, removeItem, pendingUnFavorited } = this.props;

    let itemUuid = pendingUnFavorited.find((x) => x === item.uuid);
    if (itemUuid) {
      item.isFavorite = false;
    } else {
      item.isFavorite = true;
    }

    return (
      <>
        <ListItem
          className={s.favorite_listItem}
          key={item.uuid}
          style={{
            left: this.state.left,
            marginLeft: this.state.left,
            minHeight: "150px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              minWidth: "130px",
              justifyContent: "space-between",
            }}
          >
            {/* <div
                className={s.favorite_itemFavorite}
                style={{
                  color: theme.palette.primary.main
                }}
                onClick={() => {
                  toggleUpcFavorite(item)
                }}
              >
                {item.isFavorite ? <Favorite /> : <FavoriteBorderOutlined />}
              </div> */}

            {/* <div className={s.shoppingCartIcon}>
              <Icon aria-haspopup="true" color="inherit" style={{ overflow: 'unset' }}>
                {item.quantityInCart ? (
                  <Badge badgeContent={item.quantityInCart} color="secondary">
                    <ShoppingCart />
                  </Badge>
                ) : (
                  <div style={{ height: '1em', width: '1em' }} />
                )}
              </Icon>
            </div>*/}

            <div className={s.lessItemsButton} onClick={() => removeItem(item)}>
              <RemoveCircleOutline fontSize="large" />
            </div>

            {item.quantityInCart ? (
              <Badge badgeContent={item.quantityInCart} color="secondary">
                <Avatar src={getImageUrl(item.imageUrl)} />
              </Badge>
            ) : (
              <Avatar src={getImageUrl(item.imageUrl)} />
            )}

            <div className={s.moreItemsButton} onClick={() => addItem(item)}>
              <AddCircleOutline fontSize="large" />
            </div>
          </div>

          <ListItemText
            style={{ padding: "0 16px 0 16px" }}
            className={s.listItemText}
            primary={
              <span style={{ fontSize: "smaller" }}>
                {!item.isSelect ? item.brand : null} {item.name}
              </span>
            }
            secondary={`${item.sizeDisplay}`}
          />
          <div className={s.itemPricesStack}>
            <div className={s.quantityPrice}>
              <div />
            </div>
            <div
              className={s.itemPrice}
              style={{ color: theme.palette.primary.main }}
            >
              ${(item.basePrice / 100).toFixed(2)}
            </div>
          </div>

          {isBrowser ? (
            <div className={s.itemRight}>
              <div className={s.moreItemsButton} onClick={() => addItem(item)}>
                <AddCircleOutline fontSize="large" />
              </div>
              <div className={s.numberOfItemsInCart}>
                {item.quantityInCart ? item.quantityInCart : 0}
              </div>
              <div
                className={s.lessItemsButton}
                onClick={() => removeItem(item)}
              >
                <RemoveCircleOutline fontSize="large" />
              </div>
            </div>
          ) : null}
        </ListItem>
        {/* // </div> */}
        <Divider />
        {/* // </Swipe> */}
      </>
    );
  }
}

// <Swipe
//   onSwipeLeft={position => {
//     removeItem(item);
//   }}
//   onSwipeRight={position => {
//     addItem(item);
//   }}
//   onSwipeStart={position => {
//     if (position.y < 15 && position.y > -15) {
//       setTimeout(() => this.setState({ left: 0, fixed: false }), 0);
//     }
//   }}
//   onSwipeEnd={position => {
//     setTimeout(
//       () => this.setState({ left: 0, fixed: true, addOrSubtract: "add" }),
//       300
//     );
//   }}
//   onSwipeMove={position => {
//     this.setState({
//       yPosition: Math.abs(this.state.yPosition + position.y)
//     });

//     if (position.x < -180) {
//       setTimeout(
//         () =>
//           this.setState({
//             left: this.state.left - 20,
//             addOrSubtract: "delete"
//           }),
//         1
//       );
//     }
//     if (position.x > 180) {
//       setTimeout(
//         () =>
//           this.setState({
//             left: this.state.left + 20,
//             addOrSubtract: "add"
//           }),
//         1
//       );
//     }
//   }}
//   tolerance={200}
// >
//   <div
//     className={
//       this.state.addOrSubtract === "add"
//         ? s.addBackground
//         : s.deleteBackground
//     }
//   >
//     <div
//       className={
//         this.state.addOrSubtract === "add" ? s.addText : s.deleteText
//       }
//     >
//       {this.state.left >= 0 ? "ADD" : "REMOVE"}
//     </div>
